import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/client/lib/page-title";
import { problemFor } from "@/client/lib/problems";
import { UnsubscribeLanding } from "@/features/settings/components/unsubscribe-landing";
import { unsubscribeQuery } from "@/features/settings/unsubscribe-query";

/** Outside the signed-in layout: the link is the credential, and the person may be signed out. */
export const Route = createFileRoute("/unsubscribe/$token")({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(unsubscribeQuery(params.token)),
  head: async () => {
    const { settingsCopy } = await import("@/features/settings/copy");
    return { meta: [{ title: pageTitle(settingsCopy.unsubscribe.title) }] };
  },
  component: Unsubscribe,
  // Email is still on when the write failed, and the page must say so rather than look finished.
  errorComponent: ({ error }) => (
    <UnsubscribeLanding
      token=""
      unsubscribed={false}
      problem={problemFor(error)}
    />
  ),
});

function Unsubscribe() {
  const { token } = Route.useParams();
  const { data: unsubscribed } = useSuspenseQuery(unsubscribeQuery(token));
  return <UnsubscribeLanding token={token} unsubscribed={unsubscribed} />;
}
